let isRedirecting = false;
export const fusionAuthRedirect = (path: string, redirectUrl = window.location.href): void => {
  if (isRedirecting) return;

  const { location } = window;
  const URL = `${path}?redirect_url=${encodeURIComponent(redirectUrl)}`;

  isRedirecting = true;
  // the redirection script a bit waits that the user store data will change.
  setTimeout(() => location.assign(URL));
};
